import React from 'react';
import "../components/styles/CompanyIntro.css";
import {useNavigate} from "react-router-dom";

const CompanyIntroPage = () => {
    const navigate = useNavigate();

    // 새로 접속 시 맨 위로 이동
    window.scrollTo(0, 0);

    return (
        <div className="company-intro-container">
            {/* 히어로 섹션 */}
            <section className="hero-section">
                <button onClick={() => navigate("/products")}>
                    <img src="/images/softcat_intro.png" alt=""/>
                </button>
            </section>

            {/* 회사 소개 섹션 */}
            <section className="about-section">
                <h2>회사 소개</h2>
                <p>
                    소프트캣은 소프트웨어 개발 및 공급을 전문으로 하며, 혁신적이고 효율적인 솔루션을 통해
                    고객의 비즈니스 성장과 성공을 돕습니다.
                </p>
            </section>

            {/* 핵심 가치 섹션 */}
            <section className="core-values-section">
                <h2>핵심 가치</h2>
                <div className="values-grid">
                    <div className="value-card">
                        <h3>혁신</h3>
                        <p>끊임없는 기술 혁신으로 최적의 솔루션 제공</p>
                    </div>
                    <div className="value-card">
                        <h3>신뢰</h3>
                        <p>고객과의 신뢰를 최우선으로</p>
                    </div>
                    <div className="value-card">
                        <h3>효율</h3>
                        <p>최고의 효율을 자랑하는 소프트웨어</p>
                    </div>
                    <div className="value-card">
                        <h3>성장</h3>
                        <p>고객과 함께 성장하는 파트너</p>
                    </div>
                </div>
            </section>

            {/* 팀 섹션 */}
            <section className="team-section">
                <h2>소프트캣 팀</h2>
                <div className="team-grid">
                    <div className="team-member">
                        <div className="avatar"></div>
                        <h4>박찬엽</h4>
                        <p>대표</p>
                    </div>
                    <div className="team-member">
                        <div className="avatar"></div>
                        <h4>송재용</h4>
                        <p>직원</p>
                    </div>
                    {/*<div className="team-member">*/}
                    {/*    <div className="avatar"></div>*/}
                    {/*    <h4>박냥이</h4>*/}
                    {/*    <p>개발자</p>*/}
                    {/*</div>*/}
                </div>
            </section>

            {/* 연락처 섹션 */}
            <section className="contact-section">
                <h2>문의하기</h2>
                <p>소프트캣과 함께하고 싶으신가요? 언제든지 연락주세요!</p>
                <button className="contact-button" onClick={() => navigate("/service")}>문의하기</button>
            </section>
        </div>
    );
};

export default CompanyIntroPage;
